import { render, staticRenderFns } from "./CompaniesCard.vue?vue&type=template&id=68949d1e"
import script from "./CompaniesCard.vue?vue&type=script&lang=js"
export * from "./CompaniesCard.vue?vue&type=script&lang=js"
import style0 from "./CompaniesCard.vue?vue&type=style&index=0&id=68949d1e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports